export default __webpack_public_path__ + "static/media/close3.ff876a83.svg";